// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:1024px){[data-v-297b8bdc]::-webkit-scrollbar{width:1px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
